export default __webpack_public_path__ + "static/media/veg.08a93c27.jpg";